class ClickToggleMobileItem {
    constructor(parent, el) {
        this.root = el
        this.toggleElement = this.root
        if ('clickToggleMobileBody' in el.dataset) {
            this.toggleElement = document.body
        }
		this._init()
	}
	_init() {
        this.className = this.root.dataset.clickToggleMobile || 'open'

        const mediaQuery = window.matchMedia("(max-width: 800px)")
        this.testMediaQuery(mediaQuery)
        mediaQuery.addEventListener('change', () => {
            this.testMediaQuery(mediaQuery)
        })

        this.root.addEventListener('click', () => {
            this.clickHandler()
        })
	}

    clickHandler() {
        this.toggleElement.classList.toggle(this.className)
    }

    testMediaQuery(mediaQuery) {
        if (!mediaQuery.matches) {
            this.toggleElement.classList.remove(this.className)
        }
      }
}
class ClickToggleMobile {
	constructor(parent) {
		this._init()
	}
	_init() {
        document.querySelectorAll('[data-click-toggle-mobile]').forEach(el => {
            new ClickToggleMobileItem(this, el)
        })
	}
}

export default ClickToggleMobile
